import React from 'react';
export function Hook() {
  return <section aria-labelledby="gancho" className="w-full bg-ivory" data-id="element-75" data-mp="3vc9d4p5tbcx">
      <div className="mx-auto max-w-3xl px-6 py-16 lg:py-24" data-id="element-76" data-mp="2b6lkbvkf32wo">
        <h2 id="gancho" className="font-display text-3xl font-semibold leading-tight text-ink sm:text-[2.6rem]" data-id="element-77" data-mp="1x6k9poecoh40">
          ¿Has sentido ese nudo en el estómago al pensar que tus invitados podrían aburrirse mientras
          esperan el banquete?
        </h2>
        <p className="mt-6 font-sans text-lg leading-relaxed text-muted" data-id="element-78" data-mp="2oztbxn8hzyed">
          ¿Te despiertas a las 3 AM preocupada por si la gente realmente se divertirá o si será
          “una boda más” del montón?
        </p>
        <p className="mt-6 font-sans text-lg leading-relaxed text-muted" data-id="element-79" data-mp="2k706ex57gm18">
          La mayoría de las novias pasan meses planeando el vestido y las flores, pero olvidan lo más
          importante:{' '}
          <strong className="font-semibold text-ink" data-id="element-80" data-mp="3cn2mjeolx50c">la experiencia del invitado.</strong>
        </p>
        <p className="mt-8 font-display text-2xl italic text-wine sm:text-3xl" data-id="element-81" data-mp="2a0ebcegi7wjs">
          No dejes el éxito de tu noche al azar.
        </p>
      </div>
    </section>;
}